<template>
  <a-layout class="create-application-box">
    <a-card class="create-application" :class="fromLocation==='msg'?'msg-create-application':''" :bordered=false>
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon style="cursor:pointer;" type="left-circle" @click="back" v-if=" fromLocation==='app'" />
        <div>{{pageLayout.pageTitle}}</div>
        <span class="page-status " :class="{'page-status-yellow':params.status==='审批中','page-status-green':params.status==='审批通过'||params.status==='付款成功','page-status-red':params.status==='审批拒绝'||params.status==='付款失败','page-status-gray':params.status==='已撤回'}">{{params.status}}</span>
        <!-- <svg-ic-close class="page-close" @click="close" v-if="fromLocation==='msg'"></svg-ic-close> -->
      </div>
      <div slot="extra" style="cursor:pointer" class="extra" v-if="pageLayout.functions">
        <span v-for="(item,index) in pageLayout.functions" :key="index" style="margin-left:17px;">
          <span class="extra-trigger" @click="print" v-if="item.action==='print'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcFile'" />打印
          </span>
        </span>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedInfo && loadedLayout">
        <common-form v-if="layout.type==='commonForm'" :ref="'commonForm'" :layout="layout" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit" :need-id="false" @changed-fields="onFieldChange"></common-form>
        <multi-form :ref="'multiForm'" :layout="layout" v-if="layout.type==='multiForm'" :params="layout.field && params[layout.field]?params[layout.field]:[]" :default-params="defaultParams" :can-edit="canEdit" :need-id="false" @changed-fields="onFieldChange"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="params" @changed-fields="setSummationInfo" :from-detail="true"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" @changed-fields="onFieldChange"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'审批流数据加载中...'" v-if="loadedInfo && loadedLayout"></approval-flow>
      <a-row v-if="params.process_status && loadedInfo && loadedLayout" style="margin-top:20px;" :class="fromLocation==='msg'?'msg-submit-box':''">
        <a-textarea v-if="fromLocation==='msg'" class="msg-textarea" placeholder="请输入审批意见" v-model="comment"></a-textarea>
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="20" :style="fromLocation==='msg'?'text-align:right':''">
          <a-button type="primary" @click="approval(1)" style="width:120px;margin-right:18px;">批准</a-button>
          <a-button @click="approval(0)" style="width:120px;margin-right:18px;">退回</a-button>
          <a-button @click="visibleComment = true" style="width:120px;">评论</a-button>
        </a-col>
      </a-row>
      <div style="text-align:center" v-if="!loadedInfo || !loadedLayout">
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <form-modal :basic-modal="approvalModal" :form-layout="approvalInfolModal" :confirm-loading="confirmLoading" @submit="approvalModalSubmit" @cancel="approvalModalCancel"></form-modal>
      <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
    </a-card>
  </a-layout>
</template>

<script>
import UUID from "uuidjs";
import SvgIcAll from "../../assets/svg/ic-all-o.svg";
import CommonForm from "../../components/CommonForm.vue";
import MultiForm from "../../components/MultiForm.vue";
import Summation from "../../components/Summation.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import FormModal from "../../components/FormModal.vue";
import Upload from "../../components/Upload.vue";
import { setTimeout } from "timers";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { layoutConfig } from "../../utils/mockData.js";
import {
  getProReimburseLayout,
  getProReimburseDetail,
  getReimburseDetailApprovalFlow,
  printUrl,
  approvalApplication
} from "../../services/CommonService.js";

import {
  backInfoFormModal,
  agreeInfoFormModal
} from "../../data/formModalConfigs.js";

export default {
  components: {
    SvgIcAll,
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    Upload,
    FormModal
  },
  data() {
    return {
      introductionVisible: false,
      retreatModalVisible: false,
      canEdit: false,
      breadcrumb: [
        {
          label: "发起申请",
          path: {
            name: "launchApplication"
          }
        },
        {
          label: "待我审批详情",
          path: ""
        }
      ],
      params: {},
      defaultParams: {}, // 复制时需要用到创建用到的默认参数
      loadedLayout: false,
      loadedInfo: false,
      canSubmit: true,
      pageLayout: {},
      approvalFlowInfo: [],
      summationInfo: {},
      requestParams: {},
      cancelSource: null,
      approvalModal: {
        visible: false,
        title: "打回",
        contentTitle: "你确定拒绝报销申请吗?",
        width: 560,
        formItemLayout: {
          layout: "vertical",
          labelCol: {
            xs: { span: 24 },
            sm: { span: 24 }
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 }
          }
        }
      },
      approvalInfolModal: [],
      comment: undefined,
      fromLocation: undefined,
      confirmLoading: false,
      disabledSubmit: false,
      visibleComment: false
    };
  },

  created() {
    this.id = this.$route.query.id;
    this.fetchApprovalFlow();
    Promise.all([this.getProReimburseDetail(this.id)]).then(() => {
      this.fetchPageLayout();
    });
    this.fromLocation =
      window.location.href.indexOf("fromLocation=msg") === -1 ? "app" : "msg"; //区别是从钉钉消息进入还是应用或者浏览器
  },

  methods: {
    onFieldChange(e) {
      this.params = Object.assign({}, this.params, e);
      this.requestParams = _.cloneDeep(this.params);
    },
    setSummationInfo(e) {
      this.summationInfo = e;
    },
    // 获取整个页面表单布局
    fetchPageLayout() {
      this.loadedLayout = false;
      getProReimburseLayout({
        id: this.$route.query.id,
        show_type: "detail",
        menu_type: 2,
        ding_msg_switch:
          window.location.href.indexOf("fromLocation=msg") !== -1 ? 1 : 0
      }).then(res => {
        if (res.status === "success") {
          this.pageLayout = res.data;
          this.loadedLayout = true;
        } else {
          this.$Message.error(res.message);
          this.loadedLayout = true;
        }
      });
    },
    fetchApprovalFlow() {
      this.approvalFlowInfo = [];
      getReimburseDetailApprovalFlow({ id: this.$route.query.id }).then(res => {
        if (res.status === "success") {
          if (res.data && _.isArray(res.data)) {
            res.data.forEach((item, index) => {
              this.$set(this.approvalFlowInfo, index, item);
            });
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    // 获取详情信息
    getProReimburseDetail(id) {
      return getProReimburseDetail(id, { menu_type: 2 }).then(res => {
        if (res.status === "success") {
          this.params = Object.assign({}, this.params, res.data);
          this.loadedInfo = true;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    back() {
      this.$router.replace({
        name: "waitApprovalList",
        query: {
          apply_type: 9
        }
      });
    },
    print() {
      let url = `${window.location.origin}/api/fas/project-reimburse/${
        this.$route.query.id
      }/pdf`;
      url.replace(" ", "");
      location.href = url;
    },
    approval(e) {
      let validateResult = true;
      if (e) {
        this.$refs.commonForm.forEach(item => {
          if (!item.validateFields()) {
            validateResult = false;
          }
        });
        this.$refs.multiForm.forEach(item => {
          if (!item.validateFields()) {
            validateResult = false;
          }
        });
      }
      if (!validateResult) {
        return;
      }
      if (this.fromLocation === "msg") {
        let params = {
          applyId: this.$route.query.id,
          status: e ? 2 : 3,
          comment: this.comment,
          applyType: 9
        };
        if (params.status === 2 && this.requestParams) {
          params = { ...this.requestParams, ...params };
        }
        approvalApplication(params).then(res => {
          if (res.status === "success") {
            this.$Message.success("审批成功");
            location.reload();
          } else {
            this.$Message.error(res.message);
          }
        });
      } else {
        this.approvalModal.visible = true;
        if (e) {
          this.approvalInfolModal = agreeInfoFormModal;
          this.approvalModal.title = "同意";
          this.approvalModal.contentTitle = "你确定同意此项目报销申请吗";
          this.approvalStatus = 2;
        } else {
          this.approvalInfolModal = backInfoFormModal;
          this.approvalModal.title = "拒绝";
          this.approvalModal.contentTitle = "你确定拒绝此项目报销申请吗";
          this.approvalStatus = 3;
        }
      }
    },
    approvalModalSubmit(e) {
      let params = {
        applyId: this.$route.query.id,
        status: this.approvalStatus,
        comment: e.reason,
        applyType: 9
      };
      if (this.approvalStatus === 2 && this.requestParams) {
        params = { ...this.requestParams, ...params };
      }
      this.confirmLoading = true;
      approvalApplication(params).then(res => {
        if (res.status === "success") {
          this.approvalModal.visible = false;
          this.$Message.success("审批成功");
          this.back();
          // this.fetchApprovalFlow();
        } else {
          this.$Message.error(res.message);
        }
        this.confirmLoading = false;
      });
    },
    approvalModalCancel() {
      this.approvalModal.visible = false;
    },
    close() {
      dd.biz.navigation.quit();
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  }
};
</script>

<style lang="less">
.create-application-box {
  padding: 16px;
}
.introductionModal {
  .ant-modal-footer {
    .ant-btn-default {
      display: none;
    }
  }
}
</style>
